

import { ApplicationUserModel, CustomerModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { Guid } from '@/libs/common/functions/guid';
import { customersStore } from '@/libs/customers/+state/store';

@Component({})
export default class CustomerDialog extends Page {

    id!: string;
    dialog = false;
    valid = true;
    saving = false;
    loading = false;
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    customer : CustomerModel | null = null;
    deleteDialog = false;
    deleting = false;

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.customer?.id == Guid.EmptyGuid();
    }
    
    open (id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close () {
        this.dialog = false;
    }

    private load (): Promise<any> {
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.loadCustomer().then((e) => {
                    this.loading = false;
                    resolve(e);
                }).catch((e: any) => {
                    reject(e);
                });
            });
        }
        else {
            this.customer = {
                id: Guid.EmptyGuid(),
                code: "",
                name: ""
            } as CustomerModel;
            return new Promise((resolve, reject) => {
                resolve(null);
            });
        }
    }

    private loadCustomer() {
        return new Promise((resolve, reject) => {
            customersStore.dispatch(CrudAction.Get, { id: this.id });
            this.subscribe(customersStore, CrudReponse.Get).then((e) => {
                this.customer = e;
                resolve(e);
            }).catch((e: any) => {
                reject(e);
            });
        });
    }

    private save () {
        if (this.form.validate()) {
            const customer = {...this.customer};
            this.saving = true;
            if (this.id == Guid.EmptyGuid()) {
                customersStore.dispatch(CrudAction.Create, { item: customer });
                this.subscribe(customersStore, CrudReponse.Create).then(() => {
                    this.load().then(() => {
                        this.saving = false;
                        this.close();
                    });
                }).catch((e) => {
                    this.saving = false;
                    throw e;
                });
            }
            else {
                customersStore.dispatch(CrudAction.Update, { item: customer });
                this.subscribe(customersStore, CrudReponse.Update).then(() => {
                    this.load().then(() => {
                        this.saving = false;
                        this.close();
                    });
                }).catch((e) => {
                    this.saving = false;
                    throw e;
                });
            }
        }
    }

    deleteClick () {
        this.deleteDialog = true;
    }

    deleteCustomer () {
        this.deleting = true;
        customersStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(customersStore, CrudReponse.Delete).then((e: any) => {
            this.deleting = false;
            this.deleteDialog = false;
            this.close();
        }).catch((e: any) => {
            this.deleting = false;
        });
    }

}
